$shm_hitalama_color_pick $mol_pick
	trigger_content /
		<= Current $shm_hitalama_color_dot
			color <= color?
	bubble_content /
		<= Colors $shm_hitalama_color_switch
			value? <=> color? <= color_default \var(--mol_theme_text)
			event *
				click? <=> click? null
			colors /
				<= color_default
				\rgb(254, 244, 69)
				\rgb(250, 199, 16)
				\rgb(242, 71, 38)
				\rgb(255, 255, 255)
				\rgb(206, 231, 65)
				\rgb(143, 209, 79)
				\rgb(218, 0, 99)
				\rgb(128, 128, 128)
				\rgb(18, 205, 212)
				\rgb(12, 167, 137)
				\rgb(149, 16, 172)
				\rgb(26, 26, 26)
				\rgb(45, 155, 240)
				\rgb(65, 75, 178)
				\rgb(101, 44, 179)
